import { useEffect, useState } from "react";
import { Page, Picture, Section } from "../../../types";
import StatementUpload from "./Statement";
import DashboardSections from "./DashboardSections";

const sortSectionsByPosition = (sections: Section[]) => {
  const sortedSections = sections.sort((a, b) => a.position - b.position);
  const negativeSections = sortedSections
    .filter((section) => section.id < 0)
    .reverse();
  const positiveSections = sortedSections.filter((section) => section.id >= 0);
  return negativeSections.concat(positiveSections);
};

const sortPicturesByPosition = (pictures: Picture[]) => {
  return pictures.sort((a, b) => a.position - b.position);
};

const Dashboard = ({ currentData }: { currentData: Page[] }) => {
  const [tab, setTab] = useState<number>(0);

  const [editableData, setEditableData] = useState<Page[]>([]);
  useEffect(() => {
    setEditableData(currentData);
  }, [currentData]);

  return (
    <div style={{ color: "white" }}>
      <div style={{ display: "flex" }}>
        <button onClick={() => setTab(0)}>Arbeiten</button>
        <button
          onClick={() => {
            setTab(1);
          }}
        >
          Vita
        </button>
        <button
          onClick={() => {
            setTab(2);
          }}
        >
          Ausstellung
        </button>
        <button
          onClick={() => {
            setTab(3);
          }}
        >
          Statement
        </button>
        <button
          onClick={() => {
            setTab(4);
          }}
        >
          Aktuelles
        </button>
      </div>

      {tab === 0 && (
        <DashboardSections
          data={
            editableData.find((x) => x.title === "Arbeiten")?.sections || []
          }
          textAmount={0}
          imageAmount={-1}
          pageId={editableData.find((x) => x.title === "Arbeiten")?.id || 1}
          pageName={"Arbeiten"}
        />
      )}

      {tab === 1 && (
        <DashboardSections
          data={editableData.find((x) => x.title === "Vita")?.sections || []}
          textAmount={2}
          imageAmount={1}
          pageId={editableData.find((x) => x.title === "Vita")?.id || 2}
          pageName={"Vita"}
        />
      )}
      {tab === 2 && (
        <DashboardSections
          data={
            editableData.find((x) => x.title === "Ausstellung")?.sections || []
          }
          textAmount={1}
          imageAmount={-1}
          pageId={editableData.find((x) => x.title === "Ausstellung")?.id || 3}
          pageName={"Ausstellung"}
        />
      )}
      {tab === 3 && (
        <StatementUpload
          data={
            editableData.find((x) => x.title === "Statement")?.sections || []
          }
          pageId={editableData.find((x) => x.title === "Statement")?.id || 4}
        />
      )}
      {tab === 4 && (
        <DashboardSections
          data={
            editableData.find((x) => x.title === "Aktuelles")?.sections || []
          }
          textAmount={2}
          imageAmount={-1}
          pageId={editableData.find((x) => x.title === "Aktuelles")?.id || 5}
          pageName={"Aktuelles"}
        />
      )}
    </div>
  );
};

export { sortSectionsByPosition, sortPicturesByPosition };

export default Dashboard;
